import { render } from "./intake-form.vue?vue&type=template&id=52a574b0"
import script from "./intake-form.vue?vue&type=script&lang=js"
export * from "./intake-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__